import React from "react";
import { useLocation } from "react-router-dom";
import { activityApi } from "../../api/activity";
import { useProjects } from "../../context/ProjectsContext";
import { nextPanelActivityStep } from "../../utils/activityIdentity";

function projectKeyFromPath(pathname) {
  const match = String(pathname || "").match(/^\/dashboard\/proyectos\/([^/]+)/);
  return match?.[1] || "";
}

export default function PanelActivityTracker() {
  const location = useLocation();
  const { activeProject } = useProjects();

  React.useEffect(() => {
    if (!location.pathname.startsWith("/dashboard")) return undefined;
    const startedAt = Date.now();
    const identity = nextPanelActivityStep();
    const path = `${location.pathname}${location.search || ""}`;
    const routeProjectKey = projectKeyFromPath(location.pathname);
    const projectMatches = routeProjectKey && [activeProject?.slug, activeProject?.id, activeProject?._id].filter(Boolean).includes(routeProjectKey);
    const project = projectMatches ? activeProject : null;

    const common = {
      projectId: project?.id || project?._id || "",
      projectSlug: project?.slug || routeProjectKey,
      projectName: project?.name || "",
      sessionId: identity.sessionId,
      tabId: identity.tabId,
      step: identity.step,
      path,
      journey: {
        channel: "panel",
        sessionId: identity.sessionId,
        tabId: identity.tabId,
        step: identity.step,
        path,
      },
      metadata: { label: document.title || path },
    };

    activityApi.trackPanel({ action: "panel_route_view", ...common }).catch(() => {});
    return () => {
      activityApi.trackPanel({
        action: "panel_route_exit",
        ...common,
        durationMs: Date.now() - startedAt,
        journey: { ...common.journey, durationMs: Date.now() - startedAt },
      }).catch(() => {});
    };
  }, [location.pathname, location.search, activeProject]);

  return null;
}
